"use client";

import { Loader2Icon } from "lucide-react";

export function StatusScreen({
  title,
  text,
  loading,
}: {
  title: string;
  text?: string;
  loading?: boolean;
}) {
  return (
    <div className="flex h-full min-h-0 flex-col items-center justify-center gap-3 px-6 text-center">
      {loading ? <Loader2Icon className="size-6 animate-spin text-primary" /> : null}
      <h2 className="font-heading text-lg font-semibold">{title}</h2>
      {text ? <p className="max-w-sm text-sm leading-6 text-muted-foreground">{text}</p> : null}
    </div>
  );
}
